require('./bootstrap');

import {Components} from "./components";

new Components('body');
